const customerName = {
  methods: {
    getCustomerName: function (customer) {
      if (customer.type === 'PRIVATE') {
        return customer.firstName + ' ' + customer.lastName
      } else if (customer.type === 'COMPANY') {
        return customer.companyName
      } else {
        return customer.contactEmail
      }
    }
  }
}

export default customerName
